import { CatalystColors } from "@certa/catalyst/constants/styles";
import { Spinner } from "@certa/icons/components/Spinner";

/**
 * Fallback loader component to be used with loadable component (lazy loaded component).
 */
export const FallbackLoader = () => {
  return <Spinner color={CatalystColors.NEUTRAL_700} />;
};
